import React from 'react'
import Toast from 'components/Common/Toast'

export interface ICalendarDisconnectedToastProps {
  onClose: () => void
  onClick: () => void
  tool: string
}
const CalendarDisconnectedToast = ({ onClose, onClick, tool }: ICalendarDisconnectedToastProps) => {
  return (
    <Toast variant="alert" showCloseButton={true} onClose={onClose}>
      <p>
        We are having trouble connecting to your {tool} account.{' '}
        <span className="underline hover:cursor-pointer" onClick={onClick}>
          Please reconnect.
        </span>
      </p>
    </Toast>
  )
}

export default CalendarDisconnectedToast
